import { FormattedMessage } from "react-intl";
import Counter from "../counter/counter.component";

const Repo = () => {
  return (
    <>
      <Counter
        traget={7}
        timeOut={15}
        label={
          <FormattedMessage
            id="satisfied.clients"
            defaultMessage="Satisfied Clients"
          />
        }
      />
      <Counter
        traget={10}
        timeOut={10}
        label={
          <FormattedMessage
            id="completed.projects"
            defaultMessage="Projects Completed"
          />
        }
      />
      <Counter
        traget={4}
        timeOut={100}
        label={
          <FormattedMessage
            id="years.of.experiences"
            defaultMessage="Years Of Experience"
          />
        }
      />
    </>
  );
};
export default Repo;
